import IconBase from '@phosphor-icons/react/dist/lib/IconBase'
import type { IconProps, IconWeight } from '@phosphor-icons/react/dist/lib/types'
import { forwardRef, type ReactElement } from 'react'

// Drawn by Glow design on a 24px box (GLOW Design System, icons frame, "fridge") and scaled onto
// Phosphor's 256 grid.
const weights = new Map<IconWeight, ReactElement>([
  [
    'bold',
    <g fill="currentColor" transform="scale(10.6667) translate(4.995 0.955)">
      <path d="M11.01 11.02C11.01 10.4677 10.5623 10.02 10.01 10.02C9.45772 10.02 9.01 10.4677 9.01 11.02V13.04C9.01 13.5923 9.45772 14.04 10.01 14.04C10.5623 14.04 11.01 13.5923 11.01 13.04V11.02Z" />
      <path d="M10 5.87C10.55 5.87 11 5.42 11 4.87V3.99C11 3.44 10.55 2.99 10 2.99C9.45 2.99 9 3.44 9 3.99V4.87C9 5.42 9.45 5.87 10 5.87Z" />
      <path d="M12.64 0H1.36C0.61 0 0 0.59 0 1.31V19.68C0 20.4 0.59 21.09 1.35 21.09H3C3 21.09 3 21.09 3 21.1C3 21.65 3.45 22.1 4 22.1C4.55 22.1 5 21.65 5 21.1C5 21.1 5 21.1 5 21.09H9.01C9.01 21.09 9.01 21.09 9.01 21.1C9.01 21.65 9.46 22.1 10.01 22.1C10.56 22.1 11.01 21.65 11.01 21.1C11.01 21.1 11.01 21.1 11.01 21.09H12.65C13.4 21.09 14.01 20.41 14.01 19.68V1.31C14.01 0.59 13.4 0 12.65 0H12.64ZM12.01 19.08H2.02V9.01H12.01V19.08ZM12.01 7.01H2.02V2.03L12.01 2.01V7.02V7.01Z" />
    </g>
  ],
  [
    'fill',
    <g fill="currentColor" transform="scale(10.6667) translate(4.995 0.955)">
      <path d="M13 9.01H0V19.68C0 20.4 0.59 21.09 1.35 21.09H3C3 21.09 3 21.09 3 21.1C3 21.65 3.45 22.1 4 22.1C4.55 22.1 5 21.65 5 21.1C5 21.1 5 21.1 5 21.09H9.01C9.01 21.09 9.01 21.09 9.01 21.1C9.01 21.65 9.46 22.1 10.01 22.1C10.56 22.1 11.01 21.65 11.01 21.1C11.01 21.1 11.01 21.1 11.01 21.09H12.65C13.4 21.09 14.01 20.41 14.01 19.68V9.01H13ZM11 13.04C11 13.59 10.55 14.04 10 14.04C9.45 14.04 9 13.59 9 13.04V11.02C9 10.47 9.45 10.02 10 10.02C10.55 10.02 11 10.47 11 11.02V13.04Z" />
      <path d="M14.01 7.01V1.31C14.01 0.59 13.4 0 12.65 0H1.36C0.61 0 0 0.59 0 1.31V7.02H14.01V7.01ZM11 4.87C11 5.42 10.55 5.87 10 5.87C9.45 5.87 9 5.42 9 4.87V3.99C9 3.44 9.45 2.99 10 2.99C10.55 2.99 11 3.44 11 3.99V4.87Z" />
    </g>
  ]
])

export const Refrigerator = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase ref={ref} {...props} weights={weights} />
))
Refrigerator.displayName = 'Refrigerator'
